export default {
  tip: "提示",
  title: "原子方程智慧养殖管理平台",
  logoutTip: "退出系统, 是否继续?",
  submitText: "确定",
  cancelText: "取消",
  search: "请输入搜索内容",
  menuTip: "没有发现菜单",
  input: "请输入",
  select: "请选择",
  phone: "手机号",
  code: "验证码",
  lodingText: "正在加载中，请稍后",
  cityName: "宁波",
  headerTitle: "万理学院养殖研究试验项目",
  confirm: "确定将选择数据删除?",
  message: "操作成功",
  back:'返回',
  ok: "确定",
  cancel: "取消",
  input_s: "请选择",
  startDate: "开始时间",
  endDate: "结束时间",
  indexLabel: "序号",
  weekday: [
    "星期天",
    "星期一",
    "星期二",
    "星期三",
    "星期四",
    "星期五",
    "星期六",
  ],
  add: "新 增",
  edit: "编 辑",
  del: "删 除",
  view: "详 情",
  weather: "zh",
  more: "更多",
  total: "总数",
  total1: "合计",
  workshop: "车间",
  pool1: "一级蓄水池",
  pool2: "二级蓄水池",
  processed: "已处理",
  untreated: "未处理",
  alarming: "告警中",
  recovered: "已恢复",
  open: "开",
  close: "关",
  open1: "开",
  close1: "关",
  empty: "暂无数据",
  //首页
  wel: {
    title1: "在养期数阶段分布",
    title2: "生产情况分布",
    title3: "养殖天数趋势",
    title4: "故障日志",
    title5: "告警日志",
    title6: "库存预警",
    title7: "任务看板",
    menu: ["环境采集", "养殖看板", "养殖循环", "自动投喂", "换风换热"],
    timeOut:'超时',
    normal:'正常',
    yield: "累计产量",
    danwei: "/万尾",
    qs: "累计期数",
    danwei2: "单位：天",
    danwei3: "单位：千克",
    text: "今日",
    Death: {
      indicator: [
        {
          name: "空胃",
          max: 1000,
        },
        {
          name: "其他",
          max: 1000,
        },
        {
          name: "蓝体",
          max: 1000,
        },
        {
          name: "弓背掉苗",
          max: 1000,
        },
        {
          name: "肝胰腺",
          max: 1000,
        },
        {
          name: "白斑",
          max: 1000,
        },
        {
          name: "红腿",
          max: 1000,
        },
        {
          name: "断肠",
          max: 1000,
        },
      ],
      name: "治",
      series: [
        {
          data: [
            {
              value: [400, 400, 600, 600, 600, 600, 600, 600],
              name: "一阶",
            },
            {
              value: [800, 900, 900, 900, 900, 900, 900, 900],
              name: "二阶",
            },
            {
              value: [900, 1000, 400, 400, 400, 400, 0, 400],
              name: "三阶",
            },
          ],
        },
      ],
    },
  },
  //车间全景
  work: {
    menu: [
      "车间全景",
      "运行监测",
      "设备管理",
      "视频监测",
      "配电管理",
      "返回首页",
    ],
    title1: "养殖数据",
    title2: "告警实时统计",
    title3: "故障实时统计",
    title4:"反冲洗日志",
    legend: ["排污", "循环", "爆气", "爆氧", "排水", "告警", "故障"],
    fault: {
      title: "故障",
      Time: "故障时间",
      info: "故障描述",
      type: "故障类型",
      address: "故障地点",
      picture: "故障图像",
      status: "故障状态",
    },
    alarm: {
      title: "告警",
      id: "资源编号",
      Time: "告警时间",
      info: "告警描述",
      type: "告警类型",
      address: "告警地点",
      status: "告警状态",
    },
    DO: "溶氧",
    PH: "PH",
    TEMP: "温度",
    LC: "液位",
    blowdown: "排污",
    Loop: "循环",
    GasExplosion: "爆气",
    Oxygen: "爆氧",
    water: "推水",
    assets: "资产列表",
    usable: "可用数",
    available: "不可用数",
    pond: "养殖池(大)",
  },
  //运行监测
  running: {
    legend: ["排污", "循环", "爆气", "爆氧", "排水", "已启动", "未启动"],
    dialogTitle: "批量操作",
    assets: "养殖池列表",
    placeholder: "请输入设备名称搜索",
    reset: "重置",
    ok: "确定",
  },
  //设备管理
  device: {
    legend: ["告警", "故障", "已启动", "未启动"],
    btnTitle: "反冲水泵",
    selectData: ["砂滤", "蛋分", "微滤", "生化"],
    stress: "压力",
    backwash: "今日反冲洗",
    voltage: "电压",
    slData: ["水泵", "A阀", "B阀", "C阀"],
    dfData: ["循环泵", "反清洗阀", "臭氧"],
    title1: "设备状态数据",
    title2:'设备总览',
    message: "操作成功",
  },
  //视频监测
  video: {
    pagination: {
      pageSize: "每页显示条目数",
      total: "共",
      items: "条",
      prev: "上一页",
      next: "下一页",
      jumper: "前往",
      page: "页",
    },
    situation: "实时概况",
    recording: "录像回放",
    Monitor: "监控列表",
    control: "云台控制",
    move: "移速",
    focusing: "调焦",
    focusing1: "聚焦",
    aperture: "光圈",
    title: "录像搜索",
    start: "开始时间：",
    end: "结束时间：",
  },
  //配电管理
  power: {
    title1: "电力利用率",
    title2: "整体运行情况",
    title3: "温湿度统计",
    title4: "异常日志信息",
    title5: "输入电压",
    title6: "输出电压",
    yAxisName1: "温度:℃ 湿度:%",
    yAxisName2: "单位：%",
    label: ["日", "月"],
    headTitle: "配电柜名称",
    headInfo: "异常日志信息",
    headTime: "发生时间",
  },
  //养殖看板
  CultureData: {
    menu: ["养殖看板", "分析对比", "产量分析", "饲料分析", "返回首页"],
    Statistics: {
      text: "期数",
      text1: "投苗",
      text2: "万尾",
      text3: "产量",
      text4: "公斤",
      text5: "收益",
      text6: "元",
      text7: "基地",
      text8: "今年",
      text9: "基地车间数",
    },
    work: {
      text1: "今年期数",
      text2: "成功期数",
      text3: "今年投苗",
      text4: "今年收成",
      jdName: "一阶段",
      jdName2: "二阶段",
      jdName3: "三阶段",
    },
    title: "巡查日志",
    title1: "生长日志",
    date: "巡查日期",
    workShop: "巡查车间",
    user: "巡查人员",
    result: "巡查结果",
    date1: "检测日期",
    workShop1: "养殖车间",
    user1: "检测人员",
    result1: "检测结果",
  },
  //养殖看板=》养殖车间
  breeding: {
    menu: ["养殖车间", "返回"],
    text: "今年投苗",
    text1: "今年收成",
    text2: "今年淘汰",
    text3: "今年期数",
    text4: "成功期数",
    text5: "淘汰期数",
    text6: "在养期数",
    progress: {
      type: "类型",
      number: "投苗数",
      date: "投苗日期",
      day: "天",
    },
    harvest: "收成",
    seeding: "投苗",
    culture: "在养",
    success: "成功",
    lose: "淘汰",
    title: "历史期数",
    title2: "水质检测",
    data: [
      {
        name: "亚盐",
        value: "yy",
      },
      {
        name: "氨氮",
        value: "ad",
      },
      {
        name: "余氯",
        value: "yl",
      },
      {
        name: "PH",
        value: "ph",
      },
      {
        name: "ORP",
        value: "orp",
      },
      {
        name: "黄弧(水)",
        value: "hhs",
      },
      {
        name: "黄弧(虾)",
        value: "hhx",
      },
      {
        name: "绿弧(水)",
        value: "lhs",
      },
      {
        name: "绿弧(虾)",
        value: "lhx",
      },
    ],
    yy: "亚盐",
    ad: "氨氮",
    yl: "余氯",
    ph: "PH",
    orp: "ORP",
    hhs: "黄弧(水)",
    hhx: "黄弧(虾)",
    lhs: "绿弧(水)",
    lhx: "绿弧(虾)",
  },
  //养殖看板=》养殖期数详情
  periods: {
    menu: ["养殖期数", "分析对比", "返回"],
    qsInfo: {
      seeding: "投苗数/万尾",
      day: "养殖天数",
      phase: "养殖阶段",
      qs: "养殖期数",
      type: "养殖类型",
      status: "养殖状态",
      work: "养殖车间",
      user: "负责人",
      supplier: "海兴农",
      date: "投苗日期",
      harvest: "预计收成",
    },
    title: "水质分析",
    title1: "投喂饲料",
    title2: "生长分析",
    title3: "移苗信息",
    title4: "巡查日志",
    title5: "养殖照片",
    day: "天数",
    name: "名称",
    danwei: "投喂数/克",
    day1:'第{day}天',
    danwei1:'重量/斤',
    danwei2:'苗数/尾',
    danwei3:'出成率/%',
    title6:'照片详情',
  },
  //数据对比
  DataComparison: {
    title: "数据指标",
    title1: "养殖期数",
    placeholder: "请选择数据指标",
    placeholder1: "请选择养殖期数",
    reset: "重 置",
    analyze: "数据分析",
  },
  //产量分析
  yield: {
    title: "今年总产量(公斤)",
    text: "累计产量/公斤",
    text1: "目前期数",
    text2: "累计期数",
    title1: "厂家虾苗",
    title2: "历年养殖详情",
    title3: "车间养殖占比",
    title4: "每月虾苗",
    title5: "收虾记录",
    danwei: "单位：万尾",
    danwei1: "单位：公斤",
    danwei2: "总产量(公斤)",
    danwei3: "总期数",
    date: "日期",
    xz: "虾种",
    danwei4: "收成(公斤)",
    danwei5: "单价(元/公斤)",
    index:"序号",
    type:"种类",
    total:"投喂量(公斤)",
  },
  //饲料分析
  fodder: {
    title: "车间投喂量",
    title1: "每月投喂量",
    title2: "每月动保",
    title3: "厂家饲料",
    title4: "采购分析",
    title5: "期数投喂量(在养)",
    title6: "每月消耗",
    title7: "投喂记录",
    text: "饲料",
    text1: "投喂量(公斤)",
    text2: "今年总消耗/公斤",
  },
  //养殖循环
  CultureCycle: {
    menu: ["养殖循环", "源水总规", "源水管道", "北区进水", "返回首页"],
    title: "一单元循环",
    name: "紫外杀毒",
    name1: "生化池",
    name2: "蛋分",
    name3: "养殖池",
    name4: "清水池",
    name5: "微滤",
    run: "运行",
    stop: "停止",
    gas: "爆气",
    oxygen: "爆氧",
    pump: "水泵",
    backwash: "反冲洗",
    loop: "循环",
    blowdown: "排污",
    pwf: "排污阀",
    xhf: "循环阀",
  },
  //源水总归
  pool: {
    title: "缓冲池水位",
    title1: "源水池水位",
    title2: "水泵状态",
    title3: "砂滤压力",
    text: "启动调度",
    text1: "关闭调度",
    text2: "启动时间",
    text3: "空闲",
    text4: "加水/消毒",
    text5: "可用",
    text6: "故障/清洁",
    name: "浮球开关",
    name1: "清洁",
    name2: "正常",
    name3: "开始消毒",
    name4: "结束消毒",
    data: [
      "锅炉冷出水阀",
      "锅炉冷回水阀",
      "源水进水阀",
      "车间进水阀",
      "余热冷出水阀",
      "余热冷回水阀",
      "浮球开关",
    ],
    data1: ["进水电动阀", "出水电动阀", "加CIO2电动阀", "浮球开关"],
    name5: "加温",
    name6: "加水",
  },
  crud:{
    menu:'操 作'
  },
  //源水管道，水泵房
  conduit: {
    legend: ["反冲洗", "已启动", "未启动"],
    name: "南区进水",
    name1: "连通池",
    name2: "源水池",
    name3: "液位仪",
    name4: "北区进水",
    name5: "北区进水",
    pump: "反冲水泵",
    pump1: "排污水泵",
    valve: "反冲阀",
    text:'进',
    text1:'出',
    text2:'水泵',
    text3:'A阀',
    text4:'B阀',
    text5:'C阀',
    text6:'压力',
  },
  //饲料投喂
  feed: {
    menu: ["自动投喂", "小车管理", "路线管理", "投喂计划", "返回首页"],
    menu2: ["饲料消耗", "返回"],
    title: "机器人概况",
    title1: "投喂次数概况",
    title2: "投料概况",
    title3: "用电概况",
    name: "机器人",
    name1: "日投料",
    name2: "周投料",
    name3: "月投料",
    name4: "日用电",
    name5: "周用电",
    name6: "月用电",
  },
  //小车管理
  car: {
    title: "编号",
    title1: "小车名称",
    title2: "状态",
    placeholder: "请输入编号",
    placeholder1: "请输入小车名称",
    placeholder2: "请选择状态",
    button: "重置",
    button1: "查询",
    button2: "保存",
    button3: "取消",
    statusData: [
      { label: "空闲", value: 1 },
      { label: "运行中", value: 2 },
      { label: "充电中", value: 3 },
      { label: "故障", value: 4 },
    ],
    index: "序号",
    column: {
      label: "编号",
      label1: "小车名称",
      label2: "养殖车间",
      label3: "投喂次数",
      label4: "电量(%)",
      label5: "状态",
    },
    text: "小车信息",
    status: "运行中",
    status1: "空闲",
    status2: "充电中",
    status3: "故障",
  },
  //路线管理
  line: {
    title: "名称",
    placeholder: "请输入名称",
    title1: "路线信息",
    column: {
      label: "名称",
      label1: "投喂车间",
      label2: "投喂点",
      label3: "投喂方向",
    },
    data: {
      name1: "1号投喂池",
      name2: "2号投喂池",
      name3: "3号投喂池",
      name4: "4号投喂池",
      name5: "5号投喂池",
      name6: "6号投喂池",
      name7: "7号投喂池",
      name8: "8号投喂池l",
      name9: "9号投喂池",
      name10: "10号投喂池",
      name11: "11号投喂池",
      name12: "12号投喂池",
      direction: "向左",
      direction1: "向右",
    },
  },
  //投喂计划
  plan: {
    title: "计划名称",
    title1: "计划信息",
    column: {
      label: "计划名称",
      label1: "投喂车间",
      label2: "投喂时间",
      label3: "投喂时刻",
      label4: "投喂量",
      label5: "状态",
    },
    statusData: [
      { label: "运行", value: "运行" },
      { label: "停止", value: "停止" },
    ],
    data: {
      name: "1号车",
      name1: "2号车",
      name2: "3号车",
      time: "每天",
      status: "运行",
      status1: "停止",
      text: "投喂清单",
    },
  },
  //告警日志
  alarm: {
    menu: ["告警日志", "返回"],
    radioData: [
      {
        label: "当前告警",
        value: "1",
      },
      {
        label: "历史告警",
        value: "2",
      },
    ],
    search: {
      title: "时间",
      title1: "类型",
      title2: "等级",
      title3: "地点",
      startPlaceholder: "开始日期",
      endPlaceholder: "结束日期",
      rangeSeparator: "至",
    },
    column: {
      text: "普通",
      text1: "中级",
      text2: "紧急",
      text3: "告警中",
      text4: "已恢复",
      text5:"已失效",
      title: "告警详情",
      title1: "告警信息",
      level: "告警等级",
      label: "告警时间",
      label1: "资源编号",
      label2: "告警描述",
      label3: "告警类型",
      label4: "告警等级",
      label5: "告警地点",
      label6: "恢复时间",
      label7: "告警状态",
    },
  },
  //故障日志
  fault: {
    menu: ["故障日志", "返回"],
    search: {
      title: "时间",
      title1: "类型",
      title2: "等级",
      title3: "地点",
      title4: "状态",
      title5: "人员",
    },
    radioData: [
      {
        label: "今日故障",
        value: "0",
      },
      {
        label: "未处理故障",
        value: "1",
      },
      {
        label: "已处理故障",
        value: "2",
      },
    ],
    column: {
      title: "故障详情",
      title: "故障信息",
      label: "故障时间",
      label1: "故障描述",
      label2: "故障类型",
      label3: "故障等级",
      label4: "故障地点",
      label5: "恢复时间",
      label6: "故障状态",
      label7: "处理人",
      label8: "故障图像",
      text: "未处理",
      text1: "暂停中",
      text2: "已取消",
      taxt3: "已完成",
      text4: "处理信息",
      text5: "处理时间",
      text6: "处理人员",
      text7: "处理描述",
      text8: "处理图像",
    },
  },
  //换风换热
  heat: {
    menu: ["热泵换热", "锅炉换热", "新风监控", "返回首页"],
    title: "磁悬浮水源热泵换热系统",
    //车间新风
    air: {
      label: "风量",
      label1: "湿度",
      label2: "温度",
      title: "CO2统计",
      title1: "CO2 concentration",
      title2: "设备状态数据",
    },
  },
  //一级蓄水池
  pool_1: {
    menu: ["源水总规", "砂滤", "蛋分", "源水管道", "北区进水", "返回首页"],
  },
  //二级蓄水池
  pool_2: {
    menu: ["热水区", "管道结构", "锅炉加热", "余热回收", "返回首页"],
    text: "加水",
    title:'进水泵详情',
    title1:'出水泵详情',
    message:'确定要设置为清洁吗?',
    message1:'确定要设置为故障码?',
    message2:'确定要设置为正常吗?',
    message3:'确定要消毒吗?',
    message4:'确定取消消毒吗?',
  },
  route: {
    info: "个人信息",
    website: "原子方程官网",
    avuexwebsite: "avuex官网",
    dashboard: "首页",
    more: "更多",
    tags: "标签",
    store: "本地存储",
    api: "全局函数",
    logs: "日志监控",
    table: "表格",
    form: "表单",
    top: "返回顶部",
    data: "数据展示",
    permission: "权限",
    error: "异常页面",
    test: "测试页面",
  },
  login: {
    title: "宁海数字化养殖基地",
    info: "原子方程 智慧养殖管理平台",
    tenantId: "请输入租户ID",
    username: "请输入账号",
    password: "请输入密码",
    wechat: "微信",
    qq: "QQ",
    github: "github",
    gitee: "码云",
    phone: "手机号",
    phonePlaceholder: "请输入手机号",
    code: "验证码",
    codePlaceholder: "请输入验证码",
    submit: "登录",
    userLogin: "账号密码登录",
    phoneLogin: "手机号登录",
    thirdLogin: "第三方系统登录",
    msgText: "发送验证码",
    msgSuccess: "秒后重发",
    loginBtn: "登录",
    successMssage: "验证码发送成功",
    Technology: "原子方程科技(深圳)有限公司",
    loding: "登录中，请稍后。。。",
  },
  navbar: {
    logOut: "退出登录",
    userinfo: "个人信息",
    dashboard: "首页",
    lock: "锁屏",
    bug: "没有错误日志",
    bugs: "条错误日志",
    screenfullF: "退出全屏",
    screenfull: "全屏",
    language: "中英文",
    notice: "消息通知",
    theme: "主题",
    color: "换色",
  },
  tagsView: {
    search: "搜索",
    menu: "更多",
    clearCache: "清除缓存",
    closeOthers: "关闭其它",
    closeAll: "关闭所有",
  },
  printing: {
    feedingList: "投喂清单", //投喂清单
    code: "期数", //期数
    days: "养殖天数", //天数
    date: "日期", //日期
    workshop: "车间", //车间
    personnel: "投喂人员", //投喂人员
    time: "时刻", //时刻
    pond: "养殖池", //养殖池
    feed: "饲料(g)", //饲料(g)
    mixingMaterials: "拌料", //拌料
    mixingWater: "拌水(g)", //拌水(g)
    total: "合计(g)", //合计(g)
    total1: "计划总用量", //合计(g)
    total2: "实际总用量", //合计(g)
    prawnCracker: "虾片", //虾片
    crushedMaterial03: "0.3号料", //0.3破碎料
    seedlingMaterial1: "I号苗料", //I号苗料
    crushedMaterial05: "0.5号料", //0.5破碎料
    seedlingMaterial2: "II号苗料", //II号苗料
    crushedMaterial08: "0.8号料", //0.8破碎料
    seedlingMaterial3: "III号苗料", //III号苗料
    crushedMaterial10: "1.0号料", //1.0颗粒料
    remark: "备注", //备注
  },
  sjzx: {
    //水质记录
    export: "导出", //导出
    download: "点击下载文件", //点击下载文件
    exporting: "文件导出生成中,请等待...", //文件导出生成中,请等待...
    szjl: {
      time: "监测时间", //监测时间
      code: "养殖期数", //养殖期数
      days: "养殖天数", //养殖天数
      workshop: "养殖车间", //养殖车间
      pond: "养殖池", //养殖池
      do: "溶氧", //溶氧
      ph: "PH值", //PH值
      temperature: "温度", //温度
      liquidLevel: "液位" //液位
    },
    //生长记录
    scjl: {
      time: "检测时间", //检测时间
      code: "养殖期数", //养殖期数
      days: "养殖天数", //养殖天数
      workshop: "养殖车间", //养殖车间
      pond: "养殖池", //养殖池
      length: "体长(mm)", //体长(mm)
      weight: "体重(g)", //体重(g)
      color: "体色", //体色
      growthMomentum: "目前长势(尾)", //目前长势(尾)
      illness: "虾体病况", //虾体病况
      death: "死虾情况", //死虾情况
      status: "虾体状态", //虾体状态
      personnel: "检测人员", //检测人员
      condition: "虾体状况" //虾体状况
    },
    //检测记录
    jcjl: {
      time: "检测时间", //检测时间
      code: "养殖期数", //养殖期数
      days: "养殖天数", //养殖天数
      workshop: "检测地点", //养殖车间
      pond: "养殖池", //养殖池
      subsalt: "亚盐", //亚盐
      ammoniaNitrogen: "氨氮", //氨氮
      residualChlorine: "余氯", //余氯
      PH: "PH", //PH
      ORP: "ORP", //ORP
      VibrioFlavus_w: "黄弧(水))", //黄弧(水)
      VibrioFlavus_s: "黄弧(虾)", //黄弧(虾)
      greenVibrio_w: "绿弧(水)", //绿弧(水)
      greenVibrio_s: "绿弧(虾)", //绿弧(虾)
      personnel: "检测人员", //检测人员
      custom:'自定义检测对象', //自定义检测对象
    },
    //投喂记录
    twjl: {
      complete: "已完成", //已完成
      incomplete: "未完成", //未完成
      inProgress:'进行中',
      date: "投喂日期", //投喂日期
      code: "养殖期数", //养殖期数
      days: "养殖天数", //养殖天数
      workshop: "养殖车间", //养殖车间
      pond: "养殖池", //养殖池
      time: "时刻", //时刻
      prawnCracker: "饲料1 (g)", //虾片(g)
      seedlingMaterial1: "饲料2 (g)", //I号苗料(g)
      seedlingMaterial2: "饲料3 (g)", //II号苗料(g)
      seedlingMaterial3: "饲料4 (g)", //III号苗料(g)
      crushedMaterial03: "饲料5 (g)", //0.3破碎料(g)
      crushedMaterial05: "饲料6 (g)", //0.5破碎料(g)
      crushedMaterial08: "饲料7 (g)", //0.8破碎料(g)
      crushedMaterial10: "饲料8 (g)", //1.0颗粒料(g)
      mixingMaterials: "拌料", //拌料
      mixWeight: "拌料数量(g)", //拌料数量(g)
      mixingWater: "拌水(g)", //拌水(g)
      personnel: "投喂人员", //投喂人员
      status: "投喂状态", //投喂状态
      bl1:'拌料1',     //拌料1
      sl1:'拌料1数量(g)',   //拌料1数量(g)
      bl2:'拌料2',     //拌料2
      sl2:'拌料2数量(g)',   //拌料2数量(g)
      bl3:'拌料3',     //拌料3
      sl3:'拌料3数量(g)',   //拌料3数量(g)
      bl4:'拌料4',     //拌料4
      sl4:'拌料4数量(g)',   //拌料4数量(g)
      startTime:'开始时间',   //开始时间
      endTime:'结束时间',   //结束时间
      types:'养殖种类',   //养殖种类
      feedType:'饲料类型',   //饲料类型
      feedCode:'饲料编号' ,   //饲料编号
      feedName:'饲料名称',   //饲料名称
      planTotal:'计划用量',   //计划用量
      sjTotal:'实际用量',   //实际用量
    },
    //数据对比
    sjdb: {
      empty: "重置", //重置
      dataIndicators: "数据指标", //数据指标
      code: "养殖期数", //养殖期数
      analysis: "数据分析" //数据分析
    },
    slxh:{
      date:'养殖日期',
      yzzl:"养殖种类",
      yzDays:"养殖天数",
      status:"养殖状态",
      work:"养殖车间",
      yzjd:"养殖阶段",
      sllx:"饲料类型",
      slbh:"饲料编号",
      slmc:"饲料名称",
      sjyl:"实际用量(g)",
      xj:"小计(kg)",
      total:"合计(kg)"
    }
  },
  wljDetail:{
    title:'告警',
    title1:'故障',
    title2:'反冲洗日志',
    title3:'数据总览',

  }
};
